import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import Home from './pages/Home';
import WorkDetail from './pages/WorkDetail';
import WorkList from './pages/WorkList';

import Auth from './pages/Auth';
import Profile from './pages/Profile';
import PublicProfile from './pages/PublicProfile';
import AdminLogin from './admin/Login';
import AdminDashboard from './admin/Dashboard';
import './App.css';

// Protected route component
const ProtectedRoute = ({ children }) => {
  const token = localStorage.getItem('adminToken');
  return token ? children : <Navigate to="/admin/login" />;
};

function App() {
  const [language, setLanguage] = useState('ru');

  useEffect(() => {
    // Get language from cookie or URL
    const langFromCookie = document.cookie
      .split('; ')
      .find(row => row.startsWith('LANGUAGE_ID='))
      ?.split('=')[1];

    const langFromUrl = new URLSearchParams(window.location.search).get('lang');

    if (langFromUrl) {
      setLanguage(langFromUrl);
      document.cookie = `LANGUAGE_ID=${langFromUrl}; path=/`;
    } else if (langFromCookie) {
      setLanguage(langFromCookie);
    }
  }, []);

  const changeLanguage = (lang) => {
    setLanguage(lang);
    document.cookie = `LANGUAGE_ID=${lang}; path=/`;
    window.location.href = `/?lang=${lang}`;
  };

  return (
    <Router future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
      <div className="App">
        <Routes>
          {/* Admin routes */}
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route
            path="/admin"
            element={
              <ProtectedRoute>
                <AdminDashboard />
              </ProtectedRoute>
            }
          />

          {/* Public routes */}
          <Route path="/" element={
            <>
              <Header language={language} changeLanguage={changeLanguage} />
              <Home language={language} />
              <Footer language={language} />
            </>
          } />
          <Route path="/work" element={
            <>
              <Header language={language} changeLanguage={changeLanguage} />
              <WorkList language={language} />
              <Footer language={language} />
            </>
          } />
          <Route path="/work/:code" element={
            <>
              <Header language={language} changeLanguage={changeLanguage} />
              <WorkDetail language={language} />
              <Footer language={language} />
            </>
          } />

          <Route path="/auth" element={
            <>
              <Header language={language} changeLanguage={changeLanguage} />
              <Auth language={language} />
              <Footer language={language} />
            </>
          } />
          <Route path="/profile/:userId" element={
            <>
              <Header language={language} changeLanguage={changeLanguage} />
              <PublicProfile language={language} />
              <Footer language={language} />
            </>
          } />
          <Route path="/profile" element={
            <>
              <Header language={language} changeLanguage={changeLanguage} />
              <Profile language={language} />
              <Footer language={language} />
            </>
          } />
        </Routes>
      </div>
    </Router>
  );
}

export default App;






